import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useDownloadStockTakeReport = () => {
  const [loading, setLoading] = useState(true);

  const { enqueueSnackbar } = useSnackbar();

  const downloadStockTakeReport = ({ rowId, rowTitle }) => {
    axiosClient
      .get(`Operation/StockTake/Report?Guid=${rowId}`, {
        responseType: 'blob',
      })
      .then(res => {
        if (res.status === 200) {
          const type = res.headers['content-type'];
          const blob = new Blob([res.data], {
            type,
            encoding: 'UTF-8',
          });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `گزارش (${rowTitle}).xlsx`;
          link.click();
        } else {
          enqueueSnackbar(res.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };

  return [downloadStockTakeReport, loading];
};

export default useDownloadStockTakeReport;
